<div
	class="splashscreen"
>
	<div class="splashscreen-inner">
		<p #splashText>{{splash.text}}</p>
	</div>
</div>
